import { render, staticRenderFns } from "./IconNotificationFilled.vue?vue&type=template&id=4447cdeb"
import script from "./IconNotificationFilled.vue?vue&type=script&lang=js"
export * from "./IconNotificationFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports